import { render, staticRenderFns } from "./MenuImage.vue?vue&type=template&id=3c9b8429&scoped=true"
import script from "./MenuImage.vue?vue&type=script&lang=js"
export * from "./MenuImage.vue?vue&type=script&lang=js"
import style0 from "./MenuImage.vue?vue&type=style&index=0&id=3c9b8429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b8429",
  null
  
)

export default component.exports